import React from 'react';

import { makeClassNames, IClassNames } from '../../utils/styles';
import './liveblog-card.scss';
import Timeline from '../timeline/timeline';
import { IPost } from '../post/post';
import { LiveblogTenant } from '../../typings/liveblog-themes';

export interface ILiveblogCard {
  tenant: LiveblogTenant;
  liveblogUrl: string;
  liveblogUrlWithQP?: string;
  posts?: Array<IPost>;
  postsCardinality?: number;
  dateNow?: Date;
}

const classNames = (): IClassNames =>
  makeClassNames({
    LiveblogCard: 'liveblog-card',
  });

const LiveblogCard: React.FC<ILiveblogCard> = ({
  tenant,
  liveblogUrlWithQP,
  posts,
  postsCardinality,
  dateNow = new Date(),
}) => {
  const cn = classNames();
  const firstPosts = posts && postsCardinality ? posts?.slice(0, postsCardinality) : posts || [];

  return (
    <div className={cn.LiveblogCard}>
      {firstPosts?.length && (
        <Timeline tenant={tenant} liveblogUrl={liveblogUrlWithQP} posts={firstPosts} dateNow={dateNow} isSlimTimeline />
      )}
    </div>
  );
};

export default LiveblogCard;
